export type DownloadPlatform = "windows" | "macos" | "mobile";

export function detectDownloadPlatform(
  userAgent: string,
  maxTouchPoints = 0,
): DownloadPlatform {
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)) return "mobile";
  // iPadOS can identify itself as macOS when desktop-class browsing is enabled.
  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) return "mobile";
  if (/Macintosh|Mac OS X/i.test(userAgent)) return "macos";
  return "windows";
}
